import * as yup from "yup";

export const depotSchema = yup.object({
  name: yup.string().required("Digite um nome"),
  warehouseTypeId: yup.number().required("Escolha um armazém"),
  abbreviation: yup.string().required("Digite a abreviação"),
  from: yup.number().required("Escolha um número de início"),
  to: yup.number().required("Escolha um número de fim")
});
